<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.dict.dictAddTile') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="mt-6">
                        <v-col cols="12" >
                            <v-text-field
                                    :rules="[rules.required]"
                                    :readonly = "dataType ? true : false"
                                    :label="$vuetify.lang.t('$vuetify.custom.dict.dataType')+'*'"
                                    v-model="formData.dataType"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                    :rules="[rules.required]"
                                    :label="$vuetify.lang.t('$vuetify.custom.dict.dataCode')+'*'"
                                    v-model="formData.dataCode"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                    :rules="[rules.required]"
                                    :label="$vuetify.lang.t('$vuetify.custom.dict.dataValue')"
                                    v-model="formData.dataValue"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                    :label="$vuetify.lang.t('$vuetify.custom.dict.dictOrder')"
                                    v-model="formData.dictOrder"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                    :label="$vuetify.lang.t('$vuetify.custom.dict.dataDesc')"
                                    v-model="formData.dataDesc"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" dark  @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}</v-btn>
                <v-btn color="success" dark  @click="addDict">{{ isAdd ? $vuetify.lang.t('$vuetify.custom.addBtn') : $vuetify.lang.t('$vuetify.custom.okBtn') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style></style>
<script>
    export default {
        name: 'dict-add-edit',
        model:{
            prop:'dialog',
            event:'parent-event'
        },
        props : {
            dialog : Boolean,
            dictId : {
                type : String
            },
            dataType : {
                type : String
            },
            dataObj : {
                type : Object
            },
            isAdd : {
              type : Boolean
            },
            opTime : {
                type : Number
            }
        },
        data() {
            return {
                formData: {
                    id: '',
                    pid: this.dictId,
                    dataType: this.dataType,
                    dataCode: '',
                    dataValue: '',
                    dictOrder: '',
                    dataDesc: ''
                },
                rules: {
                    required: value => !!value || '请输入'
                },
            }
        },
        methods:{
            hiddenDialog(){
                this.$emit('parent-event',false);
                this.$refs.form.reset();
            },
            addDict() {
                if (this.$refs.form.validate()) {
                    if(this.isAdd){
                        this.$api.sysDict.dictAdd(this.formData).then(data => {
                            if (data.flag) {
                                this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.addSuccess'));
                                this.$emit('initialize');
                                this.hiddenDialog();
                            }else{
                                this.$dialog.alert(data.msg);
                                this.$refs.form.reset();
                            }
                        });
                    }else{
                        this.$api.sysDict.dictEdit(this.formData).then(data => {
                            if (data.flag) {
                                this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.updateSuccess'));
                                this.$emit('initialize');
                                this.hiddenDialog();
                            }else{
                                this.$dialog.alert(data.msg);
                                this.$refs.form.reset();
                            }
                        });
                    }
                }
            }
        },
        mounted(){
            if(!this.isAdd){
                this.formData.id = this.dataObj.id;
                this.formData.pid = this.dataObj.pid;
                this.formData.dataType = this.dataObj.dataType;
                this.formData.dataCode = this.dataObj.dataCode;
                this.formData.dataValue = this.dataObj.dataValue;
                this.formData.dictOrder = this.dataObj.dictOrder;
                this.formData.dataDesc = this.dataObj.dataDesc;
            }
        },
        watch:{
            opTime(newVal){
                if(!this.isAdd){
                    this.formData.id = this.dataObj.id;
                    this.formData.pid = this.dataObj.pid;
                    this.formData.dataType = this.dataObj.dataType;
                    this.formData.dataCode = this.dataObj.dataCode;
                    this.formData.dataValue = this.dataObj.dataValue;
                    this.formData.dictOrder = this.dataObj.dictOrder;
                    this.formData.dataDesc = this.dataObj.dataDesc;
                }else{
                    this.formData.pid = this.dictId;
                    this.formData.dataType = this.dataType;
                }
            }
        }
    }
</script>
